import(/* webpackMode: "eager" */ "/codebuild/output/src4213971629/src/doctor-dashboard/app/[locale]/(commonAuthenticatedLayout)/page.tsx");
